import { useEffect, useState } from 'react';
import DirectInput from '../../../components/directInput/DirectInput';
import ReactLoading from 'react-loading';
import { useLocation, useNavigate } from 'react-router-dom';
import { addOffersSubmit, editOffersSubmit } from '../offersFun/offersCrud';
import BackIcon from '../../../assets/icons/trvto_ArrowBack.svg';
import Dropdown from '../../../components/dropdown/Dropdown';
import DropdownReg from '../../../components/dropdownReg/DropdownReg';
import MultiSelect from '../../../components/multiselect/multiselect';
import { fetchTypesData } from '../../../components/packUploadSection/quickView/fetchTypes/FetchTypes';
import Tags from '../Tags/Tags';
import { getOrganizers } from '../../../utils/getOrganizers';
import { SingleDatePicker } from 'react-dates';
import moment from 'moment';
import Tooltip from '../../../components/tooltip/Tooltip';
import { ReactComponent as InfoI } from '../../../assets/icons/trvto_info.svg';

const OffersUpload = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const isMobile = window.innerWidth < 768;
    const expiryValues = [
        { name: 'Yes', value: true },
        { name: 'No', value: false }
    ];
    const [startFocused, setStartFocused] = useState(null);
    const [endFocused, setEndFocused] = useState(null);
    const [orgData, setOrgData] = useState([]);
    const types = ['percentage', 'fixed', 'cashback_as_coins', 'cashback_as_cash', 'next_booking', 'referral'];
    const forOptions = ['trip', 'guide', 'camp', 'act', 'ayur', 'all'];
    const [offersData, setOffersData] = useState({
        id: '',
        name: '',
        code: '',
        percentage: 0,
        min: 0,
        minPeople: 0,
        limit: 0,
        people: 0,
        expiry: false,
        type: '',
        value: 0,
        for: '',
        categories: [], // category match
        tags: [], // trip tags match
        excludedTags: [], // exclude trips with certain tags
        organizers: [],
        startsAt: '',
        endsAt: '',
        perUserLimit: 1,
        combinable: false, // can combine with other offers
        redeemAfterTripComplete: false // cashback_as_coins style or cashback after trip
    });
    const [typeSel, setTypeSel] = useState('trip');
    const [typesData, setTypesData] = useState([]);
    useEffect(() => {
        fetchTypesData(typeSel, 'Types', setTypesData);
    }, [typeSel]);

    useEffect(() => {
        const fetchOrg = async () => {
            getOrganizers(setOrgData, setLoading);
        };
        fetchOrg();
    }, []);

    useEffect(() => {
        if (!location.state) return;
        setOffersData({
            ...offersData,
            id: location.state._id,
            name: location.state.name,
            code: location.state.code,
            percentage: location.state.percentage,
            min: location.state.min,
            minPeople: location.state.minPeople,
            limit: location.state.limit,
            people: location.state.people,
            expiry: false,
            for: location.state.for,
            type: location.state.type,
            value: location.state.value,
            categories: location.state.categories,
            tags: location.state.tags,
            excludedTags: location.state.excludedTags,
            organizers: location.state.organizers,
            startsAt: moment(location.state?.startsAt),
            endsAt: moment(location.state?.endsAt),
            perUserLimit: location.state?.perUserLimit,
            combinable: location.state?.combinable,
            redeemAfterTripComplete: location.state?.redeemAfterTripComplete
        });
    }, [location.state]);
    const organizerOptions = orgData.map((org) => ({
        text: org.companyName, // what is shown
        value: org._id // what is stored
    }));
    const handleSubmit = async () => {
        if (offersData.id) {
            const res = await editOffersSubmit(
                offersData.id,
                {
                    ...offersData,
                    startsAt: moment(offersData.startsAt).toISOString(),
                    endsAt: moment(offersData.endsAt).toISOString()
                },
                setLoading
            );
            if (res === 200) {
                navigate(-1);
            }
        } else {
            const res = await addOffersSubmit(offersData, setLoading);
            if (res === 200) {
                navigate(-1);
            }
        }
    };
    const isDayBlocked = (day) => {
        return offersData.startsAt && day.isBefore(offersData.startsAt, 'day');
    };

    console.log(offersData);
    return (
        <div>
            <button className='backBtn' onClick={() => navigate(-1)}>
                <img src={BackIcon} alt='back' />
                Back to Offers
            </button>
            <h1 className='orgPackUpH1'>Create New Offer</h1>
            <div className='orgPackUpSecDiv'>
                <DirectInput
                    label='Name'
                    name='name'
                    value={offersData?.name}
                    type='text'
                    placeholder='Name'
                    setFormData={setOffersData}
                    min={3}
                    limit={50}
                    content={'Name of the offer'}
                />
                <DirectInput
                    label='Code'
                    name='code'
                    value={offersData?.code}
                    type='text'
                    placeholder='Code'
                    setFormData={setOffersData}
                    min={3}
                    limit={10}
                    content={'Code the user should use to get/apply the offer'}
                />
                <DropdownReg
                    label={'For'}
                    name={'for'}
                    value={offersData.for}
                    setFormData={setOffersData}
                    options={forOptions}
                />
                <DirectInput
                    label='Percentage'
                    name='percentage'
                    value={offersData?.percentage}
                    type='number'
                    placeholder='Percentage'
                    setFormData={setOffersData}
                    min={0}
                    limit={2}
                    content={'Percentage of discount to be given'}
                />
                <DirectInput
                    label='Min'
                    name='min'
                    value={offersData?.min}
                    type='number'
                    placeholder='Min'
                    setFormData={setOffersData}
                    min={0}
                    limit={2}
                    content={'Minimum amount to apply this offer'}
                />
                <DirectInput
                    label='Min People'
                    name='minPeople'
                    value={offersData?.minPeople}
                    type='number'
                    placeholder='Min People'
                    setFormData={setOffersData}
                    min={0}
                    limit={5}
                    content={'Minimum number of people to apply this offer'}
                />
                <DirectInput
                    label='Limit'
                    name='limit'
                    value={offersData?.limit}
                    type='number'
                    placeholder='Limit'
                    setFormData={setOffersData}
                    min={0}
                    limit={5}
                    content={'Max amount that can be given as offer'}
                />
                <DirectInput
                    label='People'
                    name='people'
                    value={offersData?.people}
                    type='number'
                    placeholder='People'
                    setFormData={setOffersData}
                    min={0}
                    limit={5}
                    content={'To how many people should we provide the offer'}
                />
                <div className='dropRegDiv'>
                    <label className='dropRegLabel'>
                        Expiry
                        <Tooltip content={'Offer is expired or not'} position='top'>
                            <span className='eyeIcon' style={{ marginLeft: '5px' }}>
                                <InfoI color='blue' width={15} height={15} />
                            </span>
                        </Tooltip>
                    </label>
                    <div className='dropRegInputDiv'>
                        <select
                            value={offersData.expiry}
                            name='expiry'
                            onChange={(e) =>
                                setOffersData((prev) => ({
                                    ...prev,
                                    expiry: e.target.value === 'true'
                                }))
                            }
                            required={true}
                            className='dropRegSelect'
                        >
                            <option value='-1'>Select</option>
                            {expiryValues.map(function (val, typeIndex) {
                                return (
                                    <option key={typeIndex} value={val.value}>
                                        {val.name}
                                    </option>
                                );
                            })}
                        </select>
                    </div>
                </div>
                <DropdownReg
                    label={'Type'}
                    name={'type'}
                    value={offersData.type}
                    setFormData={setOffersData}
                    options={types}
                />
                <MultiSelect
                    label='Category'
                    helperText='*Can select multiple types'
                    name='type'
                    value={offersData.categories || []}
                    data={typesData}
                    listAll={true}
                    closeListOnItemSelect={false}
                    onChange={(val) => {
                        setOffersData((prev) => ({
                            ...prev,
                            categories: val
                        }));
                    }}
                />
                <Tags data={offersData} setData={setOffersData} name={'tags'} />
                <Tags data={offersData} setData={setOffersData} name={'excludedTags'} />
                <MultiSelect
                    label='Organizers'
                    helperText='*Can select multiple organizers'
                    name='organizers'
                    value={offersData.organizers || []}
                    data={organizerOptions}
                    listAll={true}
                    closeListOnItemSelect={false}
                    onChange={(val) => {
                        setOffersData((prev) => ({
                            ...prev,
                            organizers: val
                        }));
                    }}
                />
                <div className='dropRegDiv'>
                    <label className='dropRegLabel'>Start Date</label>
                    <div className='dropRegInputDiv'>
                        <SingleDatePicker
                            withPortal={isMobile}
                            date={offersData.startsAt}
                            onDateChange={(date) => {
                                setOffersData((prev) => ({
                                    ...prev,
                                    startsAt: date
                                }));
                            }}
                            displayFormat='DD-MM-YYYY'
                            focused={startFocused}
                            onFocusChange={({ focused }) => setStartFocused(focused)}
                            numberOfMonths={1}
                            // isDayBlocked={isDayBlocked}
                            isOutsideRange={(day) => day.isBefore(moment(), 'day')} // Disable past dates
                            showDefaultInputIcon={true} // shows calendar icon
                            readOnly={true}
                        />
                    </div>
                </div>
                <div className='dropRegDiv'>
                    <label className='dropRegLabel'>End Date</label>
                    <div className='dropRegInputDiv'>
                        <SingleDatePicker
                            withPortal={isMobile}
                            date={offersData.endsAt}
                            onDateChange={(date) => {
                                setOffersData((prev) => ({
                                    ...prev,
                                    endsAt: date
                                }));
                            }}
                            displayFormat='DD-MM-YYYY'
                            focused={endFocused}
                            onFocusChange={({ focused }) => setEndFocused(focused)}
                            numberOfMonths={1}
                            isDayBlocked={isDayBlocked}
                            isOutsideRange={(day) => day.isBefore(moment(), 'day')} // Disable past dates
                            showDefaultInputIcon={true} // shows calendar icon
                            readOnly={true}
                        />
                    </div>
                </div>
                <DirectInput
                    label='Per User Limit'
                    name='perUserLimit'
                    value={offersData?.perUserLimit}
                    type='number'
                    placeholder='Per user limit'
                    setFormData={setOffersData}
                    min={0}
                    limit={2}
                />
                <div className='dropRegDiv'>
                    <label className='dropRegLabel'>Combinable</label>
                    <div className='dropRegInputDiv'>
                        <select
                            value={offersData.combinable}
                            name='expiry'
                            onChange={(e) =>
                                setOffersData((prev) => ({
                                    ...prev,
                                    combinable: e.target.value === 'true'
                                }))
                            }
                            required={true}
                            className='dropRegSelect'
                        >
                            <option value='-1'>Select</option>
                            {expiryValues.map(function (val, typeIndex) {
                                return (
                                    <option key={typeIndex} value={val.value}>
                                        {val.name}
                                    </option>
                                );
                            })}
                        </select>
                    </div>
                </div>
                <div className='dropRegDiv'>
                    <label className='dropRegLabel'>Redeem After Trip Complete</label>
                    <div className='dropRegInputDiv'>
                        <select
                            value={offersData.redeemAfterTripComplete}
                            name='expiry'
                            onChange={(e) =>
                                setOffersData((prev) => ({
                                    ...prev,
                                    redeemAfterTripComplete: e.target.value === 'true'
                                }))
                            }
                            required={true}
                            className='dropRegSelect'
                        >
                            <option value='-1'>Select</option>
                            {expiryValues.map(function (val, typeIndex) {
                                return (
                                    <option key={typeIndex} value={val.value}>
                                        {val.name}
                                    </option>
                                );
                            })}
                        </select>
                    </div>
                </div>
                {loading && (
                    <div className='loadingBackground'>
                        <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                    </div>
                )}

                <button type='button' className='orgPackUpSubmitBtn blueBtn' onClick={() => handleSubmit()}>
                    Submit
                </button>
            </div>
        </div>
    );
};

export default OffersUpload;
